var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-3"},[_c('inertia-link',{attrs:{"href":_vm.route('account.index')}},[_c('i',{staticClass:"bi bi-arrow-left"}),_vm._v("\n        "+_vm._s(_vm.__('Meine Organisation'))+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }